import type React from 'react';
import { withErrorBoundary } from '@/ErrorBoundary';
import TileKit from '@/legacy/TileKit';
import { VehicleContextProvider } from '~/contexts/VehicleContext';
import type { Vehicle } from '~/contracts';
import { useNativeVDPPayload } from '~/native';
import BottomFrame from './BottomFrame';
import MiddleFrame from './MiddleFrame';
import {
  useCdnBlobUrl,
  useSetSearchRequestIdCookie,
  useVehicleHref
} from './ResultTile.helpers';
import TopFrame from './TopFrame';
import useSendTileInfoEvent from './useSendTileInfoEvent';

interface ResultTileProps {
  vehicle?: Vehicle;
}

const ResultTile: React.VFC<ResultTileProps> = ({ vehicle }) => {
  const cdnBlobUrl = useCdnBlobUrl();
  const setSearchRequestCookieId = useSetSearchRequestIdCookie();
  const sendTileInfoEvent = useSendTileInfoEvent();
  const href = useVehicleHref(vehicle);
  const nativePayload = useNativeVDPPayload(vehicle?.vehicleId);

  const handleOnClick = () => {
    setSearchRequestCookieId();
    sendTileInfoEvent(vehicle);
  };

  return (
    <div
      className="result-tile m:border m:border-grey-2 m:border-solid m:rounded-md"
      data-qa="result-tile"
      id={`vehicle-${vehicle?.vehicleId}`}
    >
      <a
        data-analytics-id={null}
        data-native-payload={nativePayload}
        href={href}
        onClick={handleOnClick}
      >
        <TileKit.Shell vehicle={vehicle} cdnBlobUrl={cdnBlobUrl}>
          <TopFrame />
          <MiddleFrame />
          <BottomFrame />
        </TileKit.Shell>
      </a>
    </div>
  );
};

const ResultTileWithProvider = props => (
  <VehicleContextProvider vehicle={props.vehicle}>
    <ResultTile {...props} />
  </VehicleContextProvider>
);

export default withErrorBoundary(ResultTileWithProvider);
